/*
 * No.9 Caffè — Featured Reviews
 * Card slider: shows the scroll-progress thumb only when there are more cards
 * than fit. Touch and trackpads scroll natively; a mouse can drag the track.
 * Delegated + per-element guard so it survives Shopify section re-renders.
 */
(function () {
  if (window.__no9Reviews) return;
  window.__no9Reviews = true;

  function initSlider(grid) {
    if (grid.__no9Slider) return;
    grid.__no9Slider = true;
    const nav = grid.parentElement.querySelector('.fr-no9__nav');
    if (!nav) return;
    const thumb = nav.querySelector('.fr-no9__progress-thumb');

    function update() {
      const max = grid.scrollWidth - grid.clientWidth;
      const scrollable = max > 2;
      nav.classList.toggle('is-active', scrollable);
      grid.classList.toggle('is-scrollable', scrollable);
      grid.classList.toggle('is-end', grid.scrollLeft >= max - 2);
      if (!scrollable) return;
      if (thumb) {
        const ratio = grid.clientWidth / grid.scrollWidth; // thumb size 0..1
        const pos = grid.scrollLeft / max; // position 0..1
        thumb.style.width = ratio * 100 + '%';
        thumb.style.left = pos * (100 - ratio * 100) + '%';
      }
    }

    // Mouse drag. Snap and smooth scrolling are paused while dragging so the
    // track follows the pointer, then snap back to the nearest card on release.
    let dragX = null;
    let dragLeft = 0;
    grid.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (grid.scrollWidth - grid.clientWidth <= 2) return;
      dragX = e.clientX;
      dragLeft = grid.scrollLeft;
      grid.classList.add('is-dragging');
      grid.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    grid.addEventListener('pointermove', function (e) {
      if (dragX === null) return;
      grid.scrollLeft = dragLeft - (e.clientX - dragX);
    });
    function endDrag() {
      if (dragX === null) return;
      dragX = null;
      grid.classList.remove('is-dragging');
    }
    grid.addEventListener('pointerup', endDrag);
    grid.addEventListener('pointercancel', endDrag);
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.fr-no9__grid').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Bring a review into view when it's selected in the theme editor.
  document.addEventListener('shopify:block:select', function (e) {
    const card = e.target.closest && e.target.closest('.fr-no9__card');
    if (!card) return;
    const grid = card.parentElement;
    grid.scrollTo({ left: card.offsetLeft - grid.firstElementChild.offsetLeft });
  });
})();
